// Generated by `uv run python scripts/generate_legal_research_frontend_catalog.py`.
// Source: resources/legal_research/source_catalog.json. Do not edit directly.

export type GeneratedFederalCourtGroup = {
  label: string
  isTopLevel?: true
  primaryCodes?: string[]
  courts: Array<{ label: string; codes: string[] }>
}

// prettier-ignore
export const STATE_TO_STATE_COURT_MAP: Record<string, string[]> = {
  "alabama": ["Ala.", "Ala. Civ. App.", "Ala. Crim. App."],
  "alaska": ["Alaska", "Alaska Ct. App."],
  "arizona": ["Ariz.", "Ariz. Ct. App."],
  "arkansas": ["Ark.", "Ark. Ct. App."],
  "california": ["Cal.", "Cal. Ct. App.", "Cal. Super."],
  "colorado": ["Colo.", "Colo. App."],
  "connecticut": ["Conn.", "Conn. App. Ct."],
  "delaware": ["Del.", "Del. Ch.", "Del. Super. Ct."],
  "district of columbia": ["D.C."],
  "florida": ["Fla.", "Fla. Dist. Ct. App."],
  "georgia": ["Ga.", "Ga. Ct. App."],
  "guam": ["Guam"],
  "hawaii": ["Haw.", "Haw. Ct. App."],
  "idaho": ["Idaho", "Idaho Ct. App."],
  "illinois": ["Ill.", "Ill. App. Ct."],
  "indiana": ["Ind.", "Ind. App.", "Ind. Ct. App."],
  "iowa": ["Iowa", "Iowa Ct. App."],
  "kansas": ["Kan.", "Kan. Ct. App."],
  "kentucky": ["Ky.", "Ky. Ct. App."],
  "louisiana": ["La.", "La. Ct. App."],
  "maine": ["Me."],
  "maryland": ["Md.", "Md. Ct. Spec. App."],
  "massachusetts": ["Mass.", "Mass. App. Ct."],
  "michigan": ["Mich.", "Mich. Ct. App."],
  "minnesota": ["Minn.", "Minn. Ct. App."],
  "mississippi": ["Miss.", "Miss. Ct. App."],
  "missouri": ["Mo.", "Mo. Ct. App."],
  "montana": ["Mont."],
  "nebraska": ["Neb.", "Neb. Ct. App."],
  "nevada": ["Nev.", "Nev. App."],
  "new hampshire": ["N.H."],
  "new jersey": ["N.J.", "N.J. Super.", "N.J. Super. Law Div.", "N.J. Ch.", "N.J. Super. Ch. Div."],
  "new mexico": ["N.M.", "N.M. Ct. App."],
  "new york": ["N.Y.", "N.Y. App. Div.", "N.Y. App. Term"],
  "north carolina": ["N.C.", "N.C. Ct. App."],
  "north dakota": ["N.D.", "N.D. Ct. App."],
  "northern mariana islands": ["N. Mar. I."],
  "ohio": ["Ohio", "Ohio Ct. App."],
  "oklahoma": ["Okla.", "Okla. Civ. App.", "Okla. Crim. App."],
  "oregon": ["Or.", "Or. Ct. App."],
  "pennsylvania": ["Pa.", "Pa. Super. Ct.", "Pa. Cmmw. Ct."],
  "rhode island": ["R.I.", "R.I. Super."],
  "south carolina": ["S.C.", "S.C. Ct. App."],
  "south dakota": ["S.D."],
  "tennessee": ["Tenn.", "Tenn. Ct. App.", "Tenn. Crim. App."],
  "texas": ["Tex.", "Tex. App.", "Tex. Crim. App.", "Tex. Civ. App."],
  "utah": ["Utah", "Utah Ct. App."],
  "vermont": ["Vt."],
  "virginia": ["Va.", "Va. Ct. App."],
  "washington": ["Wash.", "Wash. Ct. App."],
  "west virginia": ["W. Va."],
  "wisconsin": ["Wis.", "Wis. Ct. App."],
  "wyoming": ["Wyo."],
}

// prettier-ignore
export const STATE_LRR_SOURCES_MAP: Record<string, string[]> = {
  "alabama": ["alabama-administrative-code", "alabama-constitution", "alabama-court-rules", "code-of-alabama"],
  "alaska": ["alaska-administrative-code", "alaska-constitution", "alaska-court-rules", "alaska-statutes"],
  "arizona": ["arizona-administrative-code", "arizona-constitution", "arizona-court-rules", "arizona-revised-statutes"],
  "arkansas": ["arkansas-administrative-code", "arkansas-code-of-1987", "arkansas-constitution", "arkansas-court-rules"],
  "california": ["california-code-of-regulations", "california-codes", "california-constitution", "ca-rules-of-court"],
  "colorado": ["colorado-administrative-code", "colorado-constitution", "colorado-court-rules", "colorado-revised-statutes"],
  "connecticut": ["connecticut-administrative-code", "connecticut-constitution", "connecticut-court-rules", "general-statutes-of-connecticut"],
  "delaware": ["delaware-administrative-code", "delaware-code", "delaware-constitution", "delaware-court-rules"],
  "district of columbia": ["district-of-columbia-administrative-code", "district-of-columbia-court-rules", "district-of-columbia-official-code"],
  "florida": ["florida-administrative-code", "florida-constitution", "florida-court-rules", "florida-statutes"],
  "georgia": ["code-of-georgia", "georgia-administrative-code", "georgia-constitution"],
  "guam": [],
  "hawaii": ["hawaii-administrative-rules", "hawaii-constitution", "hawaii-court-rules", "hawaii-revised-statutes"],
  "idaho": ["idaho-administrative-code", "idaho-code", "idaho-constitution", "idaho-court-rules"],
  "illinois": ["illinois-administrative-code", "illinois-compiled-statutes", "illinois-constitution", "illinois-court-rules"],
  "indiana": ["indiana-administrative-code", "indiana-code", "indiana-constitution", "indiana-court-rules"],
  "iowa": ["code-of-iowa", "iowa-administrative-code", "iowa-constitution", "iowa-court-rules"],
  "kansas": ["kansas-administrative-code", "kansas-constitution", "kansas-statutes"],
  "kentucky": ["kentucky-administrative-regulations", "kentucky-constitution", "kentucky-court-rules", "kentucky-revised-statutes"],
  "louisiana": ["louisiana-administrative-code", "louisiana-constitution", "louisiana-court-rules", "louisiana-revised-statutes"],
  "maine": ["maine-administrative-code", "maine-constitution", "maine-court-rules", "maine-statutes"],
  "maryland": ["code-of-maryland", "maryland-administrative-code", "maryland-constitution", "maryland-court-rules"],
  "massachusetts": ["code-of-massachusetts-regulations", "general-laws-of-massachusetts", "massachusetts-constitution", "massachusetts-court-rules"],
  "michigan": ["michigan-administrative-code", "michigan-compiled-laws", "michigan-constitution", "michigan-court-rules"],
  "minnesota": ["minnesota-administrative-rules", "minnesota-constitution", "minnesota-court-rules", "minnesota-statutes"],
  "mississippi": ["mississippi-administrative-code", "mississippi-code-1972", "mississippi-constitution", "mississippi-court-rules"],
  "missouri": ["missouri-administrative-code", "missouri-constitution", "missouri-court-rules", "missouri-revised-statutes"],
  "montana": ["montana-administrative-code", "montana-code", "montana-constitution"],
  "nebraska": ["revised-statutes-of-nebraska", "nebraska-administrative-code", "nebraska-constitution", "nebraska-rules"],
  "nevada": ["nevada-administrative-code", "nevada-constitution", "nevada-court-rules", "nevada-revised-statutes"],
  "new hampshire": ["new-hampshire-administrative-code", "new-hampshire-constitution", "new-hampshire-court-rules", "new-hampshire-revised-statutes"],
  "new jersey": ["new-jersey-administrative-code", "new-jersey-constitution", "new-jersey-rules-of-court", "new-jersey-statutes"],
  "new mexico": ["new-mexico-administrative-code", "new-mexico-constitution", "new-mexico-court-rules", "new-mexico-statutes-1978"],
  "new york": ["consolidated-laws-of-new-york", "new-york-codes-rules-and-regulations", "new-york-constitution", "unconsolidated-laws-of-new-york"],
  "north carolina": ["general-statutes-of-north-carolina", "north-carolina-administrative-code", "north-carolina-constitution", "north-carolina-court-rules"],
  "north dakota": ["north-dakota-administrative-code", "north-dakota-century-code", "north-dakota-constitution", "north-dakota-court-rules"],
  "northern mariana islands": [],
  "ohio": ["ohio-administrative-code", "ohio-constitution", "ohio-court-rules", "ohio-revised-code"],
  "oklahoma": ["oklahoma-administrative-code", "oklahoma-constitution", "oklahoma-statutes"],
  "oregon": ["oregon-administrative-code", "oregon-constitution", "oregon-court-rules", "oregon-revised-statutes"],
  "pennsylvania": ["pennsylvania-code-rules-and-regulations", "pennsylvania-constitution", "pennsylvania-statutes"],
  "rhode island": ["general-laws-of-rhode-island", "rhode-island-administrative-code", "rhode-island-constitution", "rhode-island-court-rules"],
  "south carolina": ["code-of-laws-of-south-carolina-1976", "south-carolina-code-of-regulations", "south-carolina-constitution", "south-carolina-court-rules"],
  "south dakota": ["south-dakota-administrative-rules", "south-dakota-codified-laws", "south-dakota-constitution"],
  "tennessee": ["tennessee-administrative-code", "tennessee-code", "tennessee-constitution", "tennessee-court-rules"],
  "texas": ["texas-administrative-code", "texas-codes", "texas-constitution", "texas-court-rules"],
  "utah": ["utah-administrative-code", "utah-code", "utah-constitution", "utah-court-rules"],
  "vermont": ["vermont-administrative-code", "vermont-constitution", "vermont-court-rules", "vermont-statutes"],
  "virginia": ["code-of-virginia", "virginia-administrative-code", "virginia-constitution", "virginia-court-rules"],
  "washington": ["revised-code-of-washington", "washington-administrative-code", "washington-constitution", "washington-court-rules"],
  "west virginia": ["west-virginia-administrative-code", "west-virginia-code", "west-virginia-constitution", "west-virginia-court-rules"],
  "wisconsin": ["wisconsin-administrative-code", "wisconsin-constitution", "wisconsin-court-rules", "wisconsin-statutes"],
  "wyoming": ["wyoming-administrative-code", "wyoming-constitution", "wyoming-court-rules", "wyoming-statutes"],
  "puerto rico": ["laws-of-puerto-rico"],
  "virgin islands": [],
}

// prettier-ignore
export const FEDERAL_DISTRICT_KEYS_BY_STATE: Record<string, string[]> = {
  "alabama": ["m.d. alabama", "n.d. alabama", "s.d. alabama"],
  "alaska": ["d. alaska"],
  "arizona": ["d. arizona"],
  "arkansas": ["e.d. arkansas", "w.d. arkansas"],
  "california": ["c.d. california", "e.d. california", "n.d. california", "s.d. california"],
  "colorado": ["d. colorado"],
  "connecticut": ["d. connecticut"],
  "delaware": ["d. delaware"],
  "district of columbia": ["d. district of columbia"],
  "florida": ["m.d. florida", "n.d. florida", "s.d. florida"],
  "georgia": ["m.d. georgia", "n.d. georgia", "s.d. georgia"],
  "guam": ["d. guam"],
  "hawaii": ["d. hawaii"],
  "idaho": ["d. idaho"],
  "illinois": ["c.d. illinois", "n.d. illinois", "s.d. illinois"],
  "indiana": ["n.d. indiana", "s.d. indiana"],
  "iowa": ["n.d. iowa", "s.d. iowa"],
  "kansas": ["d. kansas"],
  "kentucky": ["e.d. kentucky", "w.d. kentucky"],
  "louisiana": ["e.d. louisiana", "m.d. louisiana", "w.d. louisiana"],
  "maine": ["d. maine"],
  "maryland": ["d. maryland"],
  "massachusetts": ["d. massachusetts"],
  "michigan": ["e.d. michigan", "w.d. michigan"],
  "minnesota": ["d. minnesota"],
  "mississippi": ["n.d. mississippi", "s.d. mississippi"],
  "missouri": ["e.d. missouri", "w.d. missouri"],
  "montana": ["d. montana"],
  "nebraska": ["d. nebraska"],
  "nevada": ["d. nevada"],
  "new hampshire": ["d. new hampshire"],
  "new jersey": ["d. new jersey"],
  "new mexico": ["d. new mexico"],
  "new york": ["e.d. new york", "n.d. new york", "s.d. new york", "w.d. new york"],
  "north carolina": ["e.d. north carolina", "m.d. north carolina", "w.d. north carolina"],
  "north dakota": ["d. north dakota"],
  "ohio": ["n.d. ohio", "s.d. ohio"],
  "oklahoma": ["e.d. oklahoma", "n.d. oklahoma", "w.d. oklahoma"],
  "oregon": ["d. oregon"],
  "pennsylvania": ["e.d. pennsylvania", "m.d. pennsylvania", "w.d. pennsylvania"],
  "puerto rico": ["d. puerto rico"],
  "rhode island": ["d. rhode island"],
  "south carolina": ["d. south carolina"],
  "south dakota": ["d. south dakota"],
  "tennessee": ["e.d. tennessee", "m.d. tennessee", "w.d. tennessee"],
  "texas": ["e.d. texas", "n.d. texas", "s.d. texas", "w.d. texas"],
  "utah": ["d. utah"],
  "vermont": ["d. vermont"],
  "virgin islands": ["d. virgin islands"],
  "virginia": ["e.d. virginia", "w.d. virginia"],
  "washington": ["e.d. washington", "w.d. washington"],
  "west virginia": ["n.d. west virginia", "s.d. west virginia"],
  "wisconsin": ["e.d. wisconsin", "w.d. wisconsin"],
  "wyoming": ["d. wyoming"],
}

// prettier-ignore
export const FEDERAL_DISTRICT_TO_COURTS_MAP: Record<string, string[]> = {
  "m.d. alabama": ["11th Cir.", "M.D. Ala.", "Bankr. M.D. Ala."],
  "n.d. alabama": ["11th Cir.", "N.D. Ala.", "Bankr. N.D. Ala."],
  "s.d. alabama": ["11th Cir.", "S.D. Ala.", "Bankr. S.D. Ala."],
  "d. alaska": ["9th Cir.", "D. Alaska", "Bankr. D. Alaska", "B.A.P. 9th Cir."],
  "d. arizona": ["9th Cir.", "D. Ariz.", "Bankr. D. Ariz.", "B.A.P. 9th Cir."],
  "e.d. arkansas": ["8th Cir.", "E.D. Ark.", "Bankr. E.D. Ark.", "B.A.P. 8th Cir."],
  "w.d. arkansas": ["8th Cir.", "W.D. Ark.", "Bankr. W.D. Ark.", "B.A.P. 8th Cir."],
  "c.d. california": ["9th Cir.", "C.D. Cal.", "Bankr. C.D. Cal.", "B.A.P. 9th Cir."],
  "e.d. california": ["9th Cir.", "E.D. Cal.", "Bankr. E.D. Cal.", "B.A.P. 9th Cir."],
  "n.d. california": ["9th Cir.", "N.D. Cal.", "Bankr. N.D. Cal.", "B.A.P. 9th Cir."],
  "s.d. california": ["9th Cir.", "S.D. Cal.", "Bankr. S.D. Cal.", "B.A.P. 9th Cir."],
  "d. colorado": ["10th Cir.", "D. Colo.", "Bankr. D. Colo.", "B.A.P. 10th Cir."],
  "d. connecticut": ["2d Cir.", "D. Conn.", "Bankr. D. Conn.", "B.A.P. 2nd Cir."],
  "d. delaware": ["3d Cir.", "D. Del.", "Bankr. D. Del."],
  "d. district of columbia": ["D.C. Cir.", "D.D.C.", "Bankr. D.D.C."],
  "m.d. florida": ["11th Cir.", "M.D. Fla.", "Bankr. M.D. Fla."],
  "n.d. florida": ["11th Cir.", "N.D. Fla.", "Bankr. N.D. Fla."],
  "s.d. florida": ["11th Cir.", "S.D. Fla.", "Bankr. S.D. Fla."],
  "m.d. georgia": ["11th Cir.", "M.D. Ga.", "Bankr. M.D. Ga."],
  "n.d. georgia": ["11th Cir.", "N.D. Ga.", "Bankr. N.D. Ga."],
  "s.d. georgia": ["11th Cir.", "S.D. Ga.", "Bankr. S.D. Ga."],
  "d. guam": ["9th Cir.", "D. Guam", "Bankr. D. Guam", "B.A.P. 9th Cir."],
  "d. hawaii": ["9th Cir.", "D. Haw.", "Bankr. D. Haw.", "B.A.P. 9th Cir."],
  "d. idaho": ["9th Cir.", "D. Idaho", "Bankr. D. Idaho", "B.A.P. 9th Cir."],
  "c.d. illinois": ["7th Cir.", "C.D. Ill.", "Bankr. C.D. Ill."],
  "n.d. illinois": ["7th Cir.", "N.D. Ill.", "Bankr. N.D. Ill."],
  "s.d. illinois": ["7th Cir.", "S.D. Ill.", "Bankr. S.D. Ill."],
  "n.d. indiana": ["7th Cir.", "N.D. Ind.", "Bankr. N.D. Ind."],
  "s.d. indiana": ["7th Cir.", "S.D. Ind.", "Bankr. S.D. Ind."],
  "n.d. iowa": ["8th Cir.", "N.D. Iowa", "Bankr. N.D. Iowa", "B.A.P. 8th Cir."],
  "s.d. iowa": ["8th Cir.", "S.D. Iowa", "Bankr. S.D. Iowa", "B.A.P. 8th Cir."],
  "d. kansas": ["10th Cir.", "D. Kan.", "Bankr. D. Kan.", "B.A.P. 10th Cir."],
  "e.d. kentucky": ["6th Cir.", "E.D. Ky.", "Bankr. E.D. Ky.", "B.A.P. 6th Cir."],
  "w.d. kentucky": ["6th Cir.", "W.D. Ky.", "Bankr. W.D. Ky.", "B.A.P. 6th Cir."],
  "e.d. louisiana": ["5th Cir.", "E.D. La.", "Bankr. E.D. La."],
  "m.d. louisiana": ["5th Cir.", "M.D. La.", "Bankr. M.D. La."],
  "w.d. louisiana": ["5th Cir.", "W.D. La.", "Bankr. W.D. La."],
  "d. maine": ["1st Cir.", "D. Me.", "Bankr. D. Me.", "B.A.P. 1st Cir."],
  "d. maryland": ["4th Cir.", "D. Md.", "Bankr. D. Md."],
  "d. massachusetts": ["1st Cir.", "D. Mass.", "Bankr. D. Mass.", "B.A.P. 1st Cir."],
  "e.d. michigan": ["6th Cir.", "E.D. Mich.", "Bankr. E.D. Mich.", "B.A.P. 6th Cir."],
  "w.d. michigan": ["6th Cir.", "W.D. Mich.", "Bankr. W.D. Mich.", "B.A.P. 6th Cir."],
  "d. minnesota": ["8th Cir.", "D. Minn.", "Bankr. D. Minn.", "B.A.P. 8th Cir."],
  "n.d. mississippi": ["5th Cir.", "N.D. Miss.", "Bankr. N.D. Miss."],
  "s.d. mississippi": ["5th Cir.", "S.D. Miss.", "Bankr. S.D. Miss."],
  "e.d. missouri": ["8th Cir.", "E.D. Mo.", "Bankr. E.D. Mo.", "B.A.P. 8th Cir."],
  "w.d. missouri": ["8th Cir.", "W.D. Mo.", "Bankr. W.D. Mo.", "B.A.P. 8th Cir."],
  "d. montana": ["9th Cir.", "D. Mont.", "Bankr. D. Mont.", "B.A.P. 9th Cir."],
  "d. nebraska": ["8th Cir.", "D. Neb.", "Bankr. D. Neb.", "B.A.P. 8th Cir."],
  "d. nevada": ["9th Cir.", "D. Nev.", "Bankr. D. Nev.", "B.A.P. 9th Cir."],
  "d. new hampshire": ["1st Cir.", "D.N.H.", "Bankr. D.N.H.", "B.A.P. 1st Cir."],
  "d. new jersey": ["3d Cir.", "D.N.J.", "Bankr. D.N.J."],
  "d. new mexico": ["10th Cir.", "D.N.M.", "Bankr. D.N.M.", "B.A.P. 10th Cir."],
  "e.d. new york": ["2d Cir.", "E.D.N.Y.", "Bankr. E.D.N.Y.", "B.A.P. 2nd Cir."],
  "n.d. new york": ["2d Cir.", "N.D.N.Y.", "Bankr. N.D.N.Y.", "B.A.P. 2nd Cir."],
  "s.d. new york": ["2d Cir.", "S.D.N.Y.", "Bankr. S.D.N.Y.", "B.A.P. 2nd Cir."],
  "w.d. new york": ["2d Cir.", "W.D.N.Y.", "Bankr. W.D.N.Y.", "B.A.P. 2nd Cir."],
  "e.d. north carolina": ["4th Cir.", "E.D.N.C.", "Bankr. E.D.N.C."],
  "m.d. north carolina": ["4th Cir.", "M.D.N.C.", "Bankr. M.D.N.C."],
  "w.d. north carolina": ["4th Cir.", "W.D.N.C.", "Bankr. W.D.N.C."],
  "d. north dakota": ["8th Cir.", "D.N.D.", "Bankr. D.N.D.", "B.A.P. 8th Cir."],
  "n.d. ohio": ["6th Cir.", "N.D. Ohio", "Bankr. N.D. Ohio", "B.A.P. 6th Cir."],
  "s.d. ohio": ["6th Cir.", "S.D. Ohio", "Bankr. S.D. Ohio", "B.A.P. 6th Cir."],
  "e.d. oklahoma": ["10th Cir.", "E.D. Okla.", "Bankr. E.D. Okla.", "B.A.P. 10th Cir."],
  "n.d. oklahoma": ["10th Cir.", "N.D. Okla.", "Bankr. N.D. Okla.", "B.A.P. 10th Cir."],
  "w.d. oklahoma": ["10th Cir.", "W.D. Okla.", "Bankr. W.D. Okla.", "B.A.P. 10th Cir."],
  "d. oregon": ["9th Cir.", "D. Or.", "Bankr. D. Or."],
  "e.d. pennsylvania": ["3d Cir.", "E.D. Pa.", "Bankr. E.D. Pa."],
  "m.d. pennsylvania": ["3d Cir.", "M.D. Pa.", "Bankr. M.D. Pa."],
  "w.d. pennsylvania": ["3d Cir.", "W.D. Pa.", "Bankr. W.D. Pa."],
  "d. puerto rico": ["1st Cir.", "D.P.R.", "Bankr. D.P.R.", "B.A.P. 1st Cir."],
  "d. rhode island": ["1st Cir.", "D.R.I.", "Bankr. D.R.I.", "B.A.P. 1st Cir."],
  "d. south carolina": ["4th Cir.", "D.S.C.", "Bankr. D.S.C."],
  "d. south dakota": ["8th Cir.", "D.S.D.", "Bankr. D.S.D.", "B.A.P. 8th Cir."],
  "e.d. tennessee": ["6th Cir.", "E.D. Tenn.", "Bankr. E.D. Tenn.", "B.A.P. 6th Cir."],
  "m.d. tennessee": ["6th Cir.", "M.D. Tenn.", "Bankr. M.D. Tenn.", "B.A.P. 6th Cir."],
  "w.d. tennessee": ["6th Cir.", "W.D. Tenn.", "Bankr. W.D. Tenn.", "B.A.P. 6th Cir."],
  "e.d. texas": ["5th Cir.", "E.D. Tex.", "Bankr. E.D. Tex."],
  "n.d. texas": ["5th Cir.", "N.D. Tex.", "Bankr. N.D. Tex."],
  "s.d. texas": ["5th Cir.", "S.D. Tex.", "Bankr. S.D. Tex."],
  "w.d. texas": ["5th Cir.", "W.D. Tex.", "Bankr. W.D. Tex."],
  "d. utah": ["10th Cir.", "D. Utah", "Bankr. D. Utah", "B.A.P. 10th Cir."],
  "d. vermont": ["2d Cir.", "D. Vt.", "Bankr. D. Vt.", "B.A.P. 2nd Cir."],
  "d. virgin islands": ["3d Cir.", "D.V.I.", "Bankr. D.V.I."],
  "e.d. virginia": ["4th Cir.", "E.D. Va.", "Bankr. E.D. Va."],
  "w.d. virginia": ["4th Cir.", "W.D. Va.", "Bankr. W.D. Va."],
  "e.d. washington": ["9th Cir.", "E.D. Wash.", "Bankr. E.D. Wash.", "B.A.P. 9th Cir."],
  "w.d. washington": ["9th Cir.", "W.D. Wash.", "Bankr. W.D. Wash.", "B.A.P. 9th Cir."],
  "n.d. west virginia": ["4th Cir.", "N.D.W. Va.", "Bankr. N.D.W. Va."],
  "s.d. west virginia": ["4th Cir.", "S.D.W. Va.", "Bankr. S.D.W. Va."],
  "e.d. wisconsin": ["7th Cir.", "E.D. Wis.", "Bankr. E.D. Wis."],
  "w.d. wisconsin": ["7th Cir.", "W.D. Wis.", "Bankr. W.D. Wis."],
  "d. wyoming": ["10th Cir.", "D. Wyo.", "Bankr. D. Wyo.", "B.A.P. 10th Cir."],
}

// prettier-ignore
export const STATE_LABELS: Record<string, string> = {
  "alabama": "Alabama",
  "alaska": "Alaska",
  "arizona": "Arizona",
  "arkansas": "Arkansas",
  "california": "California",
  "colorado": "Colorado",
  "connecticut": "Connecticut",
  "delaware": "Delaware",
  "district of columbia": "District of Columbia",
  "florida": "Florida",
  "georgia": "Georgia",
  "guam": "Guam",
  "hawaii": "Hawaii",
  "idaho": "Idaho",
  "illinois": "Illinois",
  "indiana": "Indiana",
  "iowa": "Iowa",
  "kansas": "Kansas",
  "kentucky": "Kentucky",
  "louisiana": "Louisiana",
  "maine": "Maine",
  "maryland": "Maryland",
  "massachusetts": "Massachusetts",
  "michigan": "Michigan",
  "minnesota": "Minnesota",
  "mississippi": "Mississippi",
  "missouri": "Missouri",
  "montana": "Montana",
  "nebraska": "Nebraska",
  "nevada": "Nevada",
  "new hampshire": "New Hampshire",
  "new jersey": "New Jersey",
  "new mexico": "New Mexico",
  "new york": "New York",
  "north carolina": "North Carolina",
  "north dakota": "North Dakota",
  "northern mariana islands": "Northern Mariana Islands",
  "ohio": "Ohio",
  "oklahoma": "Oklahoma",
  "oregon": "Oregon",
  "pennsylvania": "Pennsylvania",
  "rhode island": "Rhode Island",
  "south carolina": "South Carolina",
  "south dakota": "South Dakota",
  "tennessee": "Tennessee",
  "texas": "Texas",
  "utah": "Utah",
  "vermont": "Vermont",
  "virginia": "Virginia",
  "washington": "Washington",
  "west virginia": "West Virginia",
  "wisconsin": "Wisconsin",
  "wyoming": "Wyoming",
}

// prettier-ignore
export const FEDERAL_DISTRICT_LABELS: Record<string, string> = {
  "m.d. alabama": "Middle District of Alabama",
  "n.d. alabama": "Northern District of Alabama",
  "s.d. alabama": "Southern District of Alabama",
  "d. alaska": "District of Alaska",
  "d. arizona": "District of Arizona",
  "e.d. arkansas": "Eastern District of Arkansas",
  "w.d. arkansas": "Western District of Arkansas",
  "c.d. california": "Central District of California",
  "e.d. california": "Eastern District of California",
  "n.d. california": "Northern District of California",
  "s.d. california": "Southern District of California",
  "d. colorado": "District of Colorado",
  "d. connecticut": "District of Connecticut",
  "d. delaware": "District of Delaware",
  "d. district of columbia": "District of Columbia",
  "m.d. florida": "Middle District of Florida",
  "n.d. florida": "Northern District of Florida",
  "s.d. florida": "Southern District of Florida",
  "m.d. georgia": "Middle District of Georgia",
  "n.d. georgia": "Northern District of Georgia",
  "s.d. georgia": "Southern District of Georgia",
  "d. guam": "District of Guam",
  "d. hawaii": "District of Hawaii",
  "d. idaho": "District of Idaho",
  "c.d. illinois": "Central District of Illinois",
  "n.d. illinois": "Northern District of Illinois",
  "s.d. illinois": "Southern District of Illinois",
  "n.d. indiana": "Northern District of Indiana",
  "s.d. indiana": "Southern District of Indiana",
  "n.d. iowa": "Northern District of Iowa",
  "s.d. iowa": "Southern District of Iowa",
  "d. kansas": "District of Kansas",
  "e.d. kentucky": "Eastern District of Kentucky",
  "w.d. kentucky": "Western District of Kentucky",
  "e.d. louisiana": "Eastern District of Louisiana",
  "m.d. louisiana": "Middle District of Louisiana",
  "w.d. louisiana": "Western District of Louisiana",
  "d. maine": "District of Maine",
  "d. maryland": "District of Maryland",
  "d. massachusetts": "District of Massachusetts",
  "e.d. michigan": "Eastern District of Michigan",
  "w.d. michigan": "Western District of Michigan",
  "d. minnesota": "District of Minnesota",
  "n.d. mississippi": "Northern District of Mississippi",
  "s.d. mississippi": "Southern District of Mississippi",
  "e.d. missouri": "Eastern District of Missouri",
  "w.d. missouri": "Western District of Missouri",
  "d. montana": "District of Montana",
  "d. nebraska": "District of Nebraska",
  "d. nevada": "District of Nevada",
  "d. new hampshire": "District of New Hampshire",
  "d. new jersey": "District of New Jersey",
  "d. new mexico": "District of New Mexico",
  "e.d. new york": "Eastern District of New York",
  "n.d. new york": "Northern District of New York",
  "s.d. new york": "Southern District of New York",
  "w.d. new york": "Western District of New York",
  "e.d. north carolina": "Eastern District of North Carolina",
  "m.d. north carolina": "Middle District of North Carolina",
  "w.d. north carolina": "Western District of North Carolina",
  "d. north dakota": "District of North Dakota",
  "n.d. ohio": "Northern District of Ohio",
  "s.d. ohio": "Southern District of Ohio",
  "e.d. oklahoma": "Eastern District of Oklahoma",
  "n.d. oklahoma": "Northern District of Oklahoma",
  "w.d. oklahoma": "Western District of Oklahoma",
  "d. oregon": "District of Oregon",
  "e.d. pennsylvania": "Eastern District of Pennsylvania",
  "m.d. pennsylvania": "Middle District of Pennsylvania",
  "w.d. pennsylvania": "Western District of Pennsylvania",
  "d. puerto rico": "District of Puerto Rico",
  "d. rhode island": "District of Rhode Island",
  "d. south carolina": "District of South Carolina",
  "d. south dakota": "District of South Dakota",
  "e.d. tennessee": "Eastern District of Tennessee",
  "m.d. tennessee": "Middle District of Tennessee",
  "w.d. tennessee": "Western District of Tennessee",
  "e.d. texas": "Eastern District of Texas",
  "n.d. texas": "Northern District of Texas",
  "s.d. texas": "Southern District of Texas",
  "w.d. texas": "Western District of Texas",
  "d. utah": "District of Utah",
  "d. vermont": "District of Vermont",
  "d. virgin islands": "District of Virgin Islands",
  "e.d. virginia": "Eastern District of Virginia",
  "w.d. virginia": "Western District of Virginia",
  "e.d. washington": "Eastern District of Washington",
  "w.d. washington": "Western District of Washington",
  "n.d. west virginia": "Northern District of West Virginia",
  "s.d. west virginia": "Southern District of West Virginia",
  "e.d. wisconsin": "Eastern District of Wisconsin",
  "w.d. wisconsin": "Western District of Wisconsin",
  "d. wyoming": "District of Wyoming",
}

// prettier-ignore
export const STANDARD_FEDERAL_COURTS: string[] = [
  "U.S.",
  "Fed. Cl.",
  "C.C.P.A.",
  "Ct. Int'l Trade",
  "U.S.T.C.",
  "B.T.A.",
  "Fed. Cir.",
]

// prettier-ignore
export const SUPREME_FEDERAL_COURTS: string[] = [
  "U.S.",
]

// prettier-ignore
export const FEDERAL_LRR_SOURCES: string[] = [
  "code-of-federal-regulations",
  "constitution-of-united-states",
  "united-states-code",
  "united-states-code.federal-rules-of-appellate-procedure",
  "united-states-code.federal-rules-of-bankruptcy-procedure",
  "united-states-code.federal-rules-of-civil-procedure",
  "united-states-code.federal-rules-of-criminal-procedure",
  "united-states-code.federal-rules-of-evidence",
]

// prettier-ignore
export const FEDERAL_COURT_GROUPS: GeneratedFederalCourtGroup[] = [
  {
    label: "Federal Courts",
    isTopLevel: true,
    courts: [
      { label: "U.S. Supreme Court", codes: ["U.S."] },
      { label: "Court of Claims", codes: ["Fed. Cl."] },
      { label: "Board of Immigration Appeals", codes: ["B.I.A."] },
      { label: "Court of Customs and Patent Appeals", codes: ["C.C.P.A."] },
      { label: "Court of Intl. Trade", codes: ["Ct. Int'l Trade"] },
      { label: "Tax Court", codes: ["U.S.T.C."] },
      { label: "Board of Tax Appeals", codes: ["B.T.A."] },
      { label: "Federal Circuit", codes: ["Fed. Cir."] },
    ],
  },
  {
    label: "D.C. Circuit",
    primaryCodes: ["D.C. Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["D.C. Cir."] },
      { label: "District of Columbia", codes: ["D.D.C."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D.D.C."] },
    ],
  },
  {
    label: "1st Circuit",
    primaryCodes: ["1st Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["1st Cir."] },
      { label: "D. Maine", codes: ["D. Me."] },
      { label: "D. Massachusetts", codes: ["D. Mass."] },
      { label: "D. New Hampshire", codes: ["D.N.H."] },
      { label: "D. Puerto Rico", codes: ["D.P.R."] },
      { label: "D. Rhode Island", codes: ["D.R.I."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Me.", "Bankr. D.N.H.", "Bankr. D. Mass.", "Bankr. D.R.I.", "Bankr. D.P.R."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 1st Cir."] },
    ],
  },
  {
    label: "2nd Circuit",
    primaryCodes: ["2d Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["2d Cir."] },
      { label: "D. Connecticut", codes: ["D. Conn."] },
      { label: "D. Vermont", codes: ["D. Vt."] },
      { label: "E.D. New York", codes: ["E.D.N.Y."] },
      { label: "N.D. New York", codes: ["N.D.N.Y."] },
      { label: "S.D. New York", codes: ["S.D.N.Y."] },
      { label: "W.D. New York", codes: ["W.D.N.Y."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Conn.", "Bankr. D. Vt.", "Bankr. N.D.N.Y.", "Bankr. S.D.N.Y.", "Bankr. E.D.N.Y.", "Bankr. W.D.N.Y."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 2nd Cir."] },
    ],
  },
  {
    label: "3rd Circuit",
    primaryCodes: ["3d Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["3d Cir."] },
      { label: "D. Delaware", codes: ["D. Del."] },
      { label: "D. New Jersey", codes: ["D.N.J."] },
      { label: "D. Virgin Islands", codes: ["D.V.I."] },
      { label: "E.D. Pennsylvania", codes: ["E.D. Pa."] },
      { label: "M.D. Pennsylvania", codes: ["M.D. Pa."] },
      { label: "W.D. Pennsylvania", codes: ["W.D. Pa."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Del.", "Bankr. D.N.J.", "Bankr. D.V.I.", "Bankr. E.D. Pa.", "Bankr. M.D. Pa.", "Bankr. W.D. Pa."] },
    ],
  },
  {
    label: "4th Circuit",
    primaryCodes: ["4th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["4th Cir."] },
      { label: "D. Maryland", codes: ["D. Md."] },
      { label: "D. South Carolina", codes: ["D.S.C."] },
      { label: "E.D. North Carolina", codes: ["E.D.N.C."] },
      { label: "M.D. North Carolina", codes: ["M.D.N.C."] },
      { label: "W.D. North Carolina", codes: ["W.D.N.C."] },
      { label: "E.D. Virginia", codes: ["E.D. Va."] },
      { label: "W.D. Virginia", codes: ["W.D. Va."] },
      { label: "N.D. West Virginia", codes: ["N.D.W. Va."] },
      { label: "S.D. West Virginia", codes: ["S.D.W. Va."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Md.", "Bankr. D.S.C.", "Bankr. E.D. Va.", "Bankr. W.D. Va.", "Bankr. N.D.W. Va.", "Bankr. S.D.W. Va.", "Bankr. E.D.N.C.", "Bankr. M.D.N.C.", "Bankr. W.D.N.C."] },
    ],
  },
  {
    label: "5th Circuit",
    primaryCodes: ["5th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["5th Cir."] },
      { label: "E.D. Louisiana", codes: ["E.D. La."] },
      { label: "M.D. Louisiana", codes: ["M.D. La."] },
      { label: "W.D. Louisiana", codes: ["W.D. La."] },
      { label: "N.D. Mississippi", codes: ["N.D. Miss."] },
      { label: "S.D. Mississippi", codes: ["S.D. Miss."] },
      { label: "E.D. Texas", codes: ["E.D. Tex."] },
      { label: "N.D. Texas", codes: ["N.D. Tex."] },
      { label: "S.D. Texas", codes: ["S.D. Tex."] },
      { label: "W.D. Texas", codes: ["W.D. Tex."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. E.D. La.", "Bankr. M.D. La.", "Bankr. W.D. La.", "Bankr. S.D. Miss.", "Bankr. N.D. Miss.", "Bankr. E.D. Tex.", "Bankr. N.D. Tex.", "Bankr. S.D. Tex.", "Bankr. W.D. Tex."] },
    ],
  },
  {
    label: "6th Circuit",
    primaryCodes: ["6th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["6th Cir."] },
      { label: "E.D. Kentucky", codes: ["E.D. Ky."] },
      { label: "W.D. Kentucky", codes: ["W.D. Ky."] },
      { label: "E.D. Michigan", codes: ["E.D. Mich."] },
      { label: "W.D. Michigan", codes: ["W.D. Mich."] },
      { label: "N.D. Ohio", codes: ["N.D. Ohio"] },
      { label: "S.D. Ohio", codes: ["S.D. Ohio"] },
      { label: "E.D. Tennessee", codes: ["E.D. Tenn."] },
      { label: "M.D. Tennessee", codes: ["M.D. Tenn."] },
      { label: "W.D. Tennessee", codes: ["W.D. Tenn."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. E.D. Ky.", "Bankr. W.D. Ky.", "Bankr. E.D. Mich.", "Bankr. W.D. Mich.", "Bankr. N.D. Ohio", "Bankr. S.D. Ohio", "Bankr. E.D. Tenn.", "Bankr. M.D. Tenn.", "Bankr. W.D. Tenn."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 6th Cir."] },
    ],
  },
  {
    label: "7th Circuit",
    primaryCodes: ["7th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["7th Cir."] },
      { label: "C.D. Illinois", codes: ["C.D. Ill."] },
      { label: "N.D. Illinois", codes: ["N.D. Ill."] },
      { label: "S.D. Illinois", codes: ["S.D. Ill."] },
      { label: "N.D. Indiana", codes: ["N.D. Ind."] },
      { label: "S.D. Indiana", codes: ["S.D. Ind."] },
      { label: "E.D. Wisconsin", codes: ["E.D. Wis."] },
      { label: "W.D. Wisconsin", codes: ["W.D. Wis."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. N.D. Ill.", "Bankr. C.D. Ill.", "Bankr. S.D. Ill.", "Bankr. N.D. Ind.", "Bankr. S.D. Ind.", "Bankr. E.D. Wis.", "Bankr. W.D. Wis."] },
    ],
  },
  {
    label: "8th Circuit",
    primaryCodes: ["8th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["8th Cir."] },
      { label: "D. Minnesota", codes: ["D. Minn."] },
      { label: "D. Nebraska", codes: ["D. Neb."] },
      { label: "D. North Dakota", codes: ["D.N.D."] },
      { label: "D. South Dakota", codes: ["D.S.D."] },
      { label: "E.D. Arkansas", codes: ["E.D. Ark."] },
      { label: "W.D. Arkansas", codes: ["W.D. Ark."] },
      { label: "N.D. Iowa", codes: ["N.D. Iowa"] },
      { label: "S.D. Iowa", codes: ["S.D. Iowa"] },
      { label: "E.D. Missouri", codes: ["E.D. Mo."] },
      { label: "W.D. Missouri", codes: ["W.D. Mo."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. E.D. Ark.", "Bankr. W.D. Ark.", "Bankr. N.D. Iowa", "Bankr. S.D. Iowa", "Bankr. D. Minn.", "Bankr. E.D. Mo.", "Bankr. W.D. Mo.", "Bankr. D. Neb.", "Bankr. D.N.D.", "Bankr. D.S.D."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 8th Cir."] },
    ],
  },
  {
    label: "9th Circuit",
    primaryCodes: ["9th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["9th Cir."] },
      { label: "D. Alaska", codes: ["D. Alaska"] },
      { label: "D. Arizona", codes: ["D. Ariz."] },
      { label: "D. Guam", codes: ["D. Guam"] },
      { label: "D. Hawaii", codes: ["D. Haw."] },
      { label: "D. Idaho", codes: ["D. Idaho"] },
      { label: "D. Montana", codes: ["D. Mont."] },
      { label: "D. Nevada", codes: ["D. Nev."] },
      { label: "D. Oregon", codes: ["D. Or."] },
      { label: "C.D. California", codes: ["C.D. Cal."] },
      { label: "E.D. California", codes: ["E.D. Cal."] },
      { label: "N.D. California", codes: ["N.D. Cal."] },
      { label: "S.D. California", codes: ["S.D. Cal."] },
      { label: "E.D. Washington", codes: ["E.D. Wash."] },
      { label: "W.D. Washington", codes: ["W.D. Wash."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Alaska", "Bankr. D. Ariz.", "Bankr. E.D. Cal.", "Bankr. N.D. Cal.", "Bankr. C.D. Cal.", "Bankr. S.D. Cal.", "Bankr. D. Guam", "Bankr. D. Haw.", "Bankr. D. Idaho", "Bankr. D. Mont.", "Bankr. D. Nev.", "Bankr. E.D. Wash.", "Bankr. W.D. Wash.", "Bankr. D. Or."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 9th Cir."] },
    ],
  },
  {
    label: "10th Circuit",
    primaryCodes: ["10th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["10th Cir."] },
      { label: "D. Colorado", codes: ["D. Colo."] },
      { label: "D. Kansas", codes: ["D. Kan."] },
      { label: "D. New Mexico", codes: ["D.N.M."] },
      { label: "D. Utah", codes: ["D. Utah"] },
      { label: "D. Wyoming", codes: ["D. Wyo."] },
      { label: "E.D. Oklahoma", codes: ["E.D. Okla."] },
      { label: "N.D. Oklahoma", codes: ["N.D. Okla."] },
      { label: "W.D. Oklahoma", codes: ["W.D. Okla."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. D. Colo.", "Bankr. D. Kan.", "Bankr. D.N.M.", "Bankr. E.D. Okla.", "Bankr. N.D. Okla.", "Bankr. W.D. Okla.", "Bankr. D. Utah", "Bankr. D. Wyo."] },
      { label: "Bankruptcy Appellate Panel", codes: ["B.A.P. 10th Cir."] },
    ],
  },
  {
    label: "11th Circuit",
    primaryCodes: ["11th Cir."],
    courts: [
      { label: "Court of Appeals", codes: ["11th Cir."] },
      { label: "M.D. Alabama", codes: ["M.D. Ala."] },
      { label: "N.D. Alabama", codes: ["N.D. Ala."] },
      { label: "S.D. Alabama", codes: ["S.D. Ala."] },
      { label: "M.D. Florida", codes: ["M.D. Fla."] },
      { label: "N.D. Florida", codes: ["N.D. Fla."] },
      { label: "S.D. Florida", codes: ["S.D. Fla."] },
      { label: "M.D. Georgia", codes: ["M.D. Ga."] },
      { label: "N.D. Georgia", codes: ["N.D. Ga."] },
      { label: "S.D. Georgia", codes: ["S.D. Ga."] },
      { label: "Bankruptcy Courts", codes: ["Bankr. M.D. Ala.", "Bankr. N.D. Ala.", "Bankr. S.D. Ala.", "Bankr. M.D. Fla.", "Bankr. N.D. Fla.", "Bankr. S.D. Fla.", "Bankr. M.D. Ga.", "Bankr. N.D. Ga.", "Bankr. S.D. Ga."] },
    ],
  },
]
